import React from 'react'
import { useNewTranslation } from 'hooks/index'
import { TextInputFieldProps } from './index'
import { useField } from 'formik'
import TextInput from 'components/Shared/Inputs/TextInput'
import RectangleButton from 'particles/Button/RectangleButton'
import FieldTitleAndSubTitle from './FieldTitleAndSubTitle'

interface AddingListFieldProps extends TextInputFieldProps {
    onClick: () => void
    buttonText?: string
    onClose?: () => void
    inputFieldTitle?: string
    inputFieldIdentifier?: string
}

const AddingListField: React.FC<AddingListFieldProps> = ({
    name = '',
    showInputLength = false,
    maxInputLength = 100,
    placeholder = '',
    width = '755px',
    title,
    subtitle,
    isRequired = false,
    buttonText,
    onClick,
    inputFieldTitle = '',
    onClose,
    isReadOnly = false,
    identifier,
    inputFieldIdentifier,
}) => {
    const [t] = useNewTranslation()
    const [, meta] = useField(name)
    const hasError = Boolean(meta.error)

    return (
        <>
            <FieldTitleAndSubTitle
                isRequired={isRequired}
                onClose={onClose}
                title={title}
                subtitle={subtitle}
                isReadOnly={isReadOnly}
                identifier={identifier}
            />

            {!isReadOnly && (
                <div className="adding-list-input-area">
                    {inputFieldTitle && (
                        <FieldTitleAndSubTitle title={inputFieldTitle} identifier={inputFieldIdentifier} />
                    )}
                    <div className={`adding-list-input ${hasError && 'error-border'}`}>
                        <TextInput
                            name={name}
                            showInputLength={showInputLength}
                            maxInputLength={maxInputLength}
                            placeholder={placeholder}
                            width={width}
                            isShowError={false}
                            isRequired={isRequired}
                        />
                        <RectangleButton
                            form="outlined"
                            size="s"
                            label={buttonText ? buttonText : t('button.addToList')}
                            onClick={(e: React.MouseEvent<HTMLButtonElement>): void => {
                                e.preventDefault()
                                onClick()
                            }}
                        />
                    </div>
                    <div className="error">{hasError && meta.error}</div>
                </div>
            )}
        </>
    )
}
export default AddingListField
